import { BaseComponent } from '../core/BaseComponent';

export interface ToastOptions {
  autohide: boolean;
  delay: number;
  position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
  onShow?: (instance: Toast) => void;
  onHide?: (instance: Toast) => void;
}

export class Toast extends BaseComponent<ToastOptions> {
  private container: HTMLElement | null = null;

  protected getDefaultOptions(): ToastOptions {
    return {
      autohide: true,
      delay: 5000,
      position: 'bottom-right'
    };
  }
  
  protected init(): void {
    super.init();
    this.container = this.getOrCreateContainer();
  }
  
  public show(message: string, type: 'info' | 'success' | 'warning' | 'danger' = 'info'): void {
    if (!this.container) return;

    this.element.className = `alert alert-${type} toast-item show`;
    this.element.innerHTML = `<span>${message}</span>`;
    this.container.appendChild(this.element);
    
    if (this.options.autohide) {
      setTimeout(() => this.hide(), this.options.delay);
    }
    
    if (this.options.onShow) this.options.onShow(this);
    this.emit('show');
  }
  
  public hide(): void {
    this.element.classList.remove('show');
    this.element.classList.add('hide');
    
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
      }
      if (this.options.onHide) this.options.onHide(this);
      this.emit('hide');
    }, 300);
  }
  
  private getOrCreateContainer(): HTMLElement {
    let container = document.querySelector(`.toast-container.position-${this.options.position}`) as HTMLElement;
    
    if (!container) {
      container = document.createElement('div');
      container.className = `toast-container position-${this.options.position}`;
      document.body.appendChild(container);
    }
    
    return container;
  }
}
